import axios, { AxiosResponse } from 'axios';

let BASE_URL: string = "";

if (process.env.NODE_ENV === "production") {
    BASE_URL = "https://customerportal-b-fhc6f3c8g6hzc4fq.westus2-01.azurewebsites.net"
} else {
    BASE_URL = "http://localhost:3001"
    //http://192.168.10.219:3001/
    //To debug via android change localhost to ip address
}

class API {
    static get token(): string | null {
        return localStorage.getItem('userToken') || null;
    }

    static set token(value: string | null) {
        if (value) {
            localStorage.setItem('userToken', value);
        } else {
            localStorage.removeItem('userToken');
        }
    }
    static async request<T>(
        endpoint: string,
        data: Record<string, any> = {},
        method: 'get' | 'post' | 'put' | 'patch' | 'delete' = "get"): Promise<AxiosResponse<T> | any> {
        // console.debug("API Call:", endpoint, data, method);
        const url = `${BASE_URL}/${endpoint}`;

        const headers = {
            Authorization: `Bearer ${API.token}`
        };

        const params = (method === "get") ? data : {};
        try {
            const response = await axios<T>({
                url,
                method,
                data,
                params,
                headers
            });
            return response.data;
        } catch (err: any) {
            console.error(err.response);
            return { message: err?.response?.data?.error?.message || "Internal server error", error: true };
        }
    }
    //Public
    static async resetPassword(data: Record<string, any> = {}) {
        let res = await this.request("user/public/resetPassword", data, "patch");
        return res;
    }
    static async loginUser(data: Record<string, any> = {}) {
        let res = await this.request("user/public/login", data, "get");
        return res;
    }
    static async verifyUser(data: Record<string, any> = {}) {
        let res = await this.request("user/public/verify-email", data, "patch");
        return res;
    }
    static async resendVerificationEmail(email: string) {
        let res = await this.request("user/public/resend-verification-email", { email }, "post");
        return res;
    }
    static async resetPasswordVerification(token: Record<string, any> = {}) {
        let res = await this.request("user/public/reset-password-verification", token, "patch");
        return res;
    }
    //User
    static async createNewUser(data: Record<string, any> = {}) {
        let res = await this.request("user/register", data, "post");
        return res;
    }
    static async getUserData(data: Record<string, any> = {}) {
        let res = await this.request("user/data", data, "get");
        return res;
    }
    static async getAllUsers() {
        let res = await this.request("user/getAllUsers", {}, "get");
        return res;
    }
    static async createUser(data: Record<string, any> = {}) {
        let res = await this.request("user/create", data, "post");
        return res;
    }
    static async editUser(data: Record<string, any> = {}) {
        let res = await this.request("user", data, "patch");
        return res;
    }
    //Customers
    static async getCustomers() {
        let res = await this.request("customers");
        return res;
    }
    //Locations
    static async getLocationsByCustomer(customer: Record<string, any> = {}) {
        let res = await this.request("locations", customer, "get");
        return res;
    }
    static async getLocationsByUser(data: Record<string, any> = {}) {
        let res = await this.request("locations/userLocations", data);
        return res;
    }
    static async getLocationLabData(data: Record<string, any> = {}) {
        let res = await this.request("sheetsData/getDataByLocationId", data, "get");
        return res;
    }
    //Images
    static async getImages(data: Record<string, any> = {}) {
        let res = await this.request("images", data, "get");
        return res;
    }
    //Analytics
    static async getAnalyticsData(data: Record<string, any> = {}) {
        let res = await this.request("agri-star", data, "get");
        return res;
    }
    //Home
    //Crop Health 
    static async getStorageHealthConfig(data: Record<string, any> = {}) {
        let res = await this.request("home/storage-health", data, "get");
        return res;
    }
    static async saveStorageHealthConfig(data: Record<string, any> = {}) {
        let res = await this.request("home/storage-health/config", data, "post");
        return res;
    }
    // static async getCropHealthData(data: Record<string, any> = {}) {
    //     let res = await this.request("home/crop-health", data, "get");
    //     return res;
    // }
    //Notifications
    static async getCustomerNotifications(data: Record<string, any> = {}) {
        let res = await this.request("notifications", data, "get");
        return res;
    }
    static async dismissNotification(data: Record<string, any> = {}) {
        let res = await this.request("notifications", data, "delete");
        return res;
    }
    //Sheets Data
    static async getSheetsHistory(data: Record<string, any> = {}) {
        let res = await this.request("sheetsData/sheetsHistory", data, "get");
        return res;
    }
    //Inspections
    static async getBaysByLocation(data: Record<string, any> = {}) {
        let res = await this.request("inspections/bays", data, "get");
        return res;
    }
    static async addInspection(data: Record<string, any> = {}) {
        let res = await this.request("inspections", data, "post");
        return res;
    }
    static async getInspections(data: Record<string, any> = {}) {
        let res = await this.request("inspections", data, "get");
        return res;
    }
    static async getInspectionById(data: Record<string, any> = {}) {
        let res = await this.request(`inspections/${data.id}`, {}, "get");
        return res;
    }
    static async updateInspection(data: Record<string, any> = {}) {
        let res = await this.request(`inspections/${data.id}`, data, "put");
        return res;
    }
    static async deleteInspection(data: Record<string, any> = {}) {
        let res = await this.request(`inspections/${data.id}`, {}, "delete");
        return res;
    }

    // Analytics Presets
    static async getPresets() {
        let res = await this.request("agri-star/presets", {}, "get");
        return res;
    }

    static async savePreset(data: { name: string, config: any }) {
        let res = await this.request("agri-star/presets", data, "post");
        return res;
    }

    static async updatePreset(id: number, data: { name: string, config: any }) {
        let res = await this.request(`agri-star/presets/${id}`, data, "put");
        return res;
    }

    static async deletePreset(id: number) {
        let res = await this.request(`agri-star/presets/${id}`, {}, "delete");
        return res;
    }
}

export default API;